var _path, _path2, _ellipse, _ellipse2, _ellipse3, _ellipse4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 54,
    viewBox: "0 0 36 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.49 50.0152C25.5972 50.0152 32.98 42.6546 32.98 33.575C32.98 24.4953 25.5972 17.1348 16.49 17.1348C7.38282 17.1348 0 24.4953 0 33.575C0 42.6546 7.38282 50.0152 16.49 50.0152Z",
    fill: "url(#paint0_linear_977_1509)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7718 36.5162L19.8474 34.0354C19.2703 33.2906 18.919 32.3963 18.8333 31.4592L18.1391 23.7109C18.1391 22.8034 17.4003 22.0669 16.4901 22.0669C15.5798 22.0669 14.8411 22.8034 14.8411 23.7109L14.2128 31.742C14.0891 33.3202 14.7339 34.8623 15.9459 35.8865L19.4401 38.8408C20.0849 39.4836 21.1287 39.4836 21.7718 38.8408C22.4166 38.1997 22.4166 37.1574 21.7718 36.5162Z",
    fill: "#C6B7E6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.5313,
    cy: 52.4803,
    rx: 15.5469,
    ry: 1.51961,
    fill: "#C6B7E6",
    fillOpacity: 0.3
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.0426,
    cy: 14.6122,
    rx: 3.9576,
    ry: 3.94565,
    fill: "url(#paint1_linear_977_1509)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.9073,
    cy: 3.15652,
    rx: 3.16608,
    ry: 3.15652,
    fill: "url(#paint2_linear_977_1509)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.2144,
    cy: 9.15652,
    rx: 3.16608,
    ry: 3.15652,
    fill: "url(#paint3_linear_977_1509)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_977_1509",
    x1: 7.12368,
    y1: 10.8217,
    x2: 33.1138,
    y2: 67.3043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C00FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3B6FB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_977_1509",
    x1: 36.0002,
    y1: 19.3469,
    x2: 30.0839,
    y2: 12.6216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63BBAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82D3C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_977_1509",
    x1: 27.9073,
    y1: 0,
    x2: 27.9073,
    y2: 6.31304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9806A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2B194"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_977_1509",
    x1: 19.2144,
    y1: 6,
    x2: 19.2144,
    y2: 12.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4481F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79A2E2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.46ec83e33b3ff9d5349f557b6702cd53.svg";
export { ForwardRef as ReactComponent };